import { relations } from 'drizzle-orm';
import { roles } from '../models/roles';
import { tenants } from '../models/tenants';
import { userRoles } from '../models/userRoles';
import { roleResourcePermissions } from '../models/roleResourcePermissions';

/**
 * @group Role
 * @summary Role relations for the database schema
 *
 * @remarks
 * Defines the relationships for the roles table, including tenant, userRoles, and permissions.
 *
 * @example
 * ```typescript
 * import { roleRelations } from '@shared/db';
 *
 * // Query role with tenant and permissions
 * const roleWithDetails = await db.query.roles.findFirst({
 *   where: eq(roles.id, roleId),
 *   with: {
 *     tenant: true,
 *     userRoles: true,
 *     roleResourcePermissions: true,
 *     targetRolePermissions: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
roleRelations = relations(roles, ({ one, many }) => ({
  tenant: one(tenants, {
    fields: [roles.tenant_id],
    references: [tenants.id],
  }),
  userRoles: many(userRoles),
  roleResourcePermissions: many(roleResourcePermissions),
  // Self-referencing relation for target roles in permissions
  targetRolePermissions: many(roleResourcePermissions, {
    relationName: 'targetRole',
  }),
})); 